// src/styles/inject-globals.mjs
import globalStyles from './variables.css.mjs';

const fonts = 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Jersey+10&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Roboto:ital,wght@0,100..900;1,100..900&family=STIX+Two+Text:wght@400..700&family=Telex&display=swap&family=Domine:wght@400..700&display=swap"';

// Preload Google Fonts
const preloadLink = document.createElement('link');
preloadLink.href = fonts;
preloadLink.rel = 'preload';
preloadLink.as = 'style';
document.head.appendChild(preloadLink);

// Inject Google Fonts link
const fontLink = document.createElement('link');
fontLink.href = fonts;
fontLink.rel = 'stylesheet';
fontLink.onload = () => console.log('Fonts loaded successfully');
fontLink.onerror = () => console.error('Failed to load Fonts');
document.head.appendChild(fontLink);

// Inject global styles
const styleTag = document.createElement('style');
preloadLink.rel = 'preload';
preloadLink.as = 'style';
styleTag.textContent = globalStyles;
document.head.appendChild(styleTag);